import axios from "axios";
import router from "../router";
import { Message, Loading } from "element-ui";
import config from "./config";

/**
 *  测试环境
 * https://test.yulin365.net/api/v1
 */

const request = axios.create({
  // baseURL: "https://www.yulin365.net/api/v1",
  baseURL: config.api_base_url,
  timeout: 600000
});

const loadingInstance = {
  _target: null,
  _count: 0
};

function closeLoading(options) {
  if (options.loading && loadingInstance._count > 0) {
    loadingInstance._count--;
  }
  if (options.loading && loadingInstance._count === 0) {
    loadingInstance._target.close();
    loadingInstance._target = null;
  }
}

function handleCloseLoading(options) {
  console.log("options", options);
  console.log('---------------------------', options.isLoading)
  if(!options){
    return
  }
  if (options.isLoading) {
    loadingInstance._count--;
    console.log('loading-------------')
    console.log(loadingInstance._count===0)
    if (loadingInstance._count === 0) {
      loadingInstance._target.close();
      loadingInstance._target = null;
    }
  }
}

// 请求拦截器
request.interceptors.request.use(
  function(config) {
    // console.log("config", config);
    // console.log("istoken", config.isToken);
    let token = localStorage.getItem("token");
    if (config.isToken === true) {
      config.headers["x-api-key"] = token;
      if (config.params) {
        config.params["access-token"] = token;
      } else {
        config.params = {};
        config.params["access-token"] = token;
      }
    }

    if (config.isLoading === true) {
      loadingInstance._count++;
      if (loadingInstance._count === 1) {
        loadingInstance._target = Loading.service({
          lock: true,
          text: "加载中……"
          // text: 'Loading',
          // spinner: 'el-icon-loading',
          // background: 'rgba(0, 0, 0, 0.7)'
        });
      }
    }
    return config;
  },
  function(err) {
    return Promise.reject(err);
  }
);

// 响应拦截器
request.interceptors.response.use(
  function(response) {
    console.log("response", response);
    let { code, data, message } = response.data;
    // closeLoading(response.config);
    handleCloseLoading(response.config);
    if (code < 200 || code > 299) {
      // 请求失败
      console.log("codeaaa");
      switch (code) {
        case 401:
          localStorage.removeItem("token");
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;
        case 403:
          router.push({
            path: "/bindwechat"
          });
          Message.closeAll();
          Message.warning("请绑定微信号！");
          break;
      }
      return Promise.reject(response.data);
    } else {
      // 请求成功
      console.log("bb");
      return response.data;
    }
  },
  function(err) {
    console.log("err", err);
    // closeLoading(err.config);
    handleCloseLoading(err.config);
    return Promise.reject(err);
  }
);

export default request;



// WEBPACK FOOTER //
// ./src/request/axios.js